import axios from 'axios';
import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { storeData } from '../store/action';
import { AdminUrls } from '../network/config';

const queryString = require('query-string');

const access_URL = AdminUrls.AUTH.ACCESSTOKEN;

class App extends React.Component {
  constructor() {
    super();
    this.dashboardContentHandler = this.dashboardContentHandler.bind(this);

    this.state = {
      SourceUser: '',
      token: '',
      navrole: 'Member',
      submitted: false,
      login: false,
      login_error: false,
      queuecount: '',
      dashboardContent: [],
      mainLoading: false,
    };
    this.controller = new AbortController();

    const item = window.location.href;

    const values = item.substring(item.indexOf('?') + 1);

    let queries = queryString.parse(values);
    this.state.token = queries.token;
    this.state.SourceUser = queries.SourceUser;
    // this.setState({ SourceUser: queries.SourceUser, token: queries.token });
    //console.log(this.state);
  }

  dashboardContentHandler() {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(
        access_URL +
          '?externalAccessToken=' +
          this.state.token +
          '&provider=ATI&sourceUser=' +
          this.state.SourceUser,
        {
          method: 'GET',
          signal: this.controller.signal,
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        if (response.data) {
          // save data to local storage
          localStorage.setItem('access_token', response.data.access_token);
          localStorage.setItem('displayName', response.data.displayName);
          localStorage.setItem('expires_in', response.data.expires_in);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('source', response.data?.source);
          localStorage.setItem(
            'successMessage',
            'Hello ' + response.data.displayName
          );

          //Login user to site
          this.setState({
            login: true,
            mainLoading: false,
          });

          this.props.addData(
            response.data.access_token,
            response.data.displayName,
            response.data.role,
            response.data.token_type
          );
        }
      })

      .catch((error) => {});
  }

  componentDidMount() {
    this.dashboardContentHandler();
    let successMessage = localStorage.getItem('successMessage');
    // console.log(this.props.user);
    if (successMessage) {
      localStorage.removeItem('successMessage');
      NotificationManager.success(successMessage, 'Login Successful');
    }
  }

  render() {
    if (this.state.login) {
      return <Redirect to="/home" />;
    } else {
      return (
        <div>
          <div className="modal-header ng-scope" align="center">
            <img
              className="img-circle"
              id="img_logo"
              src={process.env.PUBLIC_URL + '/images/MyCPDLogoImage.jpg'}
              alt="logo"
            />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addData: (access_token, displayName, role, token_type) =>
      dispatch(storeData(access_token, displayName, role, token_type)),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));

//export default connect(mapStateToProps)(servicelogin);
